module.exports = __webpack_public_path__ + "media/assets/images/blog/headphones-customer-service-small-d298d38c221c17aa36c1321ef44dd8ae.jpeg";